module.exports = __webpack_public_path__ + "img/nflow1.50041764.png";